module.exports = __webpack_public_path__ + "static/media/rs.8d51c4ce.svg";